export default {
	text: {
		abort: 'Annuleren',
		automatic: 'Automatisch',
		autodrop: 'Automatisch zoeken',
		bib: 'StNr',
		class: 'Categorie',
		club: 'Vereniging',
		confirmHeatEnd: 'Weet je zeker dat je het onderdeel wilt beëindigen?',
		comment: 'Opmerking',
		deviceName: 'Naam apparaat',
		displayFocusWatch: 'Toon talmklok',
		drop: 'Opties',
		dropAfterN: 'Beste {n} na orginele startlijst',
		editValue: 'Resultaat bewerken',
		entrants: 'Atleten',
		error500: 'Server werkt niet, neem contact op met de beheerder',
		errorLogin: 'Inloggen mislukt',
		errorFirstTryDrop: 'De startpoging mag niet worden teruggedraaid.',
		errorResultFound: 'Er zijn al resultaten opgegeven. Toch verwijderen?',
		errorInvalidInput: 'Invoer leidt tot een ongeldig totaalresultaat. Gelieve dit na te kijken!',
		errorMissingData: 'Geen data gevonden',
		errorNoServerConnection: 'Geen verbinding met de server',
		errorUnknowen: 'Onbekende fout',
		eventOverview: 'Wedstrijd overzicht',
		global: 'Globaal',
		height: 'Hoogte',
		heightManager: 'Hoogte instellen',
		heightShort: 'm',
		hideEliminated: 'Verberg geëlimineerde atleten',
		interval: 'Interval',
		jumpOff: 'Barrage',
		language: 'Taal',
		lang: {
			'de-DE': 'Duits',
			'en-US': 'Engels (US)',
			'en-EN': 'Engels (UK)',
			'fr-CH': 'Frans (CH)',
			'nl-NL': 'Nederlands'
		},
		letIt: 'Vertrekken',
		listView: 'Lijstweergave',
		loading: 'Laden...',
		login: 'Aanmelden',
		logout: 'Uitloggen',
		manual: 'Handmatig',
		message: 'Bericht',
		notStartetError: 'Wedstrijd nog niet gestart',
		name: 'Naam',
		next: 'Volgende',
		noData: 'Geen gegevens beschikbaar',
		noRankingShort: 'Plaats',
		order: 'Positie',
		orderIn: 'Sorteren',
		overview: 'Overzicht',
		password: 'Wachtwoord',
		poolMerge: 'Groepen samenvoegen',
		poolMergeMessage: {
			request: 'Weet je het zeker dat je de groepen wilt samenvoegen?',
			errorToLessGroups: 'Te weinig groepen om samen te voegen',
			errorAlreadyMerged: 'De groepen zijn al samengevoegd',
			errorResultsMissing: 'Nog niet alle resultaten zijn ingevoerd',
			errorResultsMissing: 'Samenvoegen is niet mogelijk voor deze wedstrijd',
			mergeDone: 'De groepen zijn samengevoegd op een ander apparaat. Je wordt doorgestuurd naar het wedstrijdoverzicht',
		},
		rank: 'Volgorde',
		ranking: 'Plaatsen',
		redCard: 'Rode kaart',
		refresh: 'Verversen',
		reset: 'Terugzetten',
		result: 'Resultaat',
		resultEdit: 'Resultaat invoer',
		save: 'Opslaan',
		send: 'Verzenden',
		setCurrent: 'Indienen',
		setStartHeight: 'Stel de starthoogte in',
		settings: 'Instellingen',
		seperateClasses: 'Groepen apart behandelen',
		showEliminated: 'Toon geëlimineerde atleten',
		startHeat: 'Start wedstrijd',
		status: 'Status',
		startlist: 'Startlijst',
		state: {
			can: 'DNF',
			dns: 'DNS',
			dsq: 'DQ',
			finished: 'OK',
		},
		stopHeat: 'Onderdeel beëindigen',
		singleHeight: "Enkele hoogte",
		toastTimeLabel: 'Bericht weergave tijd',
		toEntrie: 'Aan de atleet',
		try: 'Poging',
		tryAutoLogin: 'Probeer automatische login',
		tryShort: 'P',
		wind: 'Wind',
		windShort: 'W',
		wkbHelp: 'Oproep voor hulp',
		yellowCard: 'Gele kaart',
	},
};
